import theme from './theme';
import { settings } from './settings';
import { routerConfig } from './router';

export default theme;
export { settings, routerConfig }